import { renderCell } from '../../assetData/table_config';

const surveryTableDetails = (units) => {
  return [
    {
      field: 'md',
      headerName: `MD (${units?.md?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'inc',
      headerName: `Inc (${units?.inc?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'az',
      headerName: `Az (${units?.az?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'tvd',
      headerName: `TVD (${units?.tvd?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'ns',
      headerName: `NS (${units?.ns?.label})`,
      width: 150,
      editable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'ew',
      headerName: `EW (${units?.ew?.label})`,
      width: 150,
      editable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'dls',
      headerName: `DLS (${units?.dls?.label})`,
      width: 220,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'vs',
      headerName: 'VS',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
  ];
};

const windowTableDetails = (units) => {
  return [
    {
      field: 'md',
      headerName: `Measured Depth (${units?.md?.label})`,
      width: 250,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        return isNaN(value) ? params.value : value.toFixed(units?.md?.decimals);
      },
      renderCell
    },
    {
      field: 'pp',
      headerName: `Pore Pressure (${units?.pp?.label})`,
      width: 250,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        return isNaN(value) ? params.value : value.toFixed(units?.pp?.decimals);
      },
      renderCell
    },
    {
      field: 'fp',
      headerName: `Fracture Pressure (${units?.fp?.label})`,
      width: 250,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        return isNaN(value) ? params.value : value.toFixed(units?.fp?.decimals);
      },
      renderCell
    },
  ];
};

const geometryTableDetails = (units) => {
  return [
    {
      field: 'type',
      headerName: 'Type',
      width: 250,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'top_md',
      headerName: `Start MD (${units?.top_md?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'shoe_md',
      headerName: `End MD (${units?.shoe_md?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'id',
      headerName: `ID (${units?.id?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
  ];
};

const drillStringTableDetails = (units) => {
  return [
    {
      field: 'name',
      headerName: 'Name',
      width: 250,
      renderCell,
      editable: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'od',
      headerName: `OD (${units?.od?.label})`,
      width: 120,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'id',
      headerName: `ID (${units?.id?.label})`,
      width: 120,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'tj_od',
      headerName: `TJ OD (${units?.tj_od?.label})`,
      width: 135,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'tj_id',
      headerName: `TJ ID (${units?.tj_id?.label})`,
      width: 135,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'len',
      headerName: `LENGTH (${units?.len?.label})`,
      width: 135,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'tj_len%',
      headerName: 'TJ LENGTH (%)',
      width: 170,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};

const drillFluidTableDetails = (units, renderActions) => {
  return [
    {
      field: 'name',
      headerName: 'Name',
      width: 190,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        const name = params?.row?.name || '';
        const md = params?.row?.MD || 0;
        return `${name.replace(/\s+/g, '')} @ ${md.toFixed(units?.MD?.decimals)}${units?.MD?.label}`;
      }
    },
    {
      field: 'mw',
      headerName: `MW (${units?.details?.mw?.label})`,
      width: 112,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'fann_600',
      headerName: 'FANN600',
      width: 112,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'fann_300',
      headerName: 'FANN300',
      width: 112,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'fann_200',
      headerName: 'FANN200',
      width: 112,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'fann_100',
      headerName: 'FANN100',
      width: 120,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'fann_6',
      headerName: 'FANN6',
      width: 120,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'fann_3',
      headerName: 'FANN3',
      width: 120,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'pv',
      headerName: `PV (${units?.details?.pv?.label})`,
      width: 120,
      headerAlign: 'center',
      align: 'center',
      renderCell,
      valueGetter: params => {
        if (params?.row?.fann_600 && params?.row?.fann_300 && (params?.row?.fann_300 < params?.row?.fann_600) && (params?.row?.fann_200 < params?.row?.fann_300)) {
          const pv = params.row.fann_600 - params.row.fann_300;
          return pv.toFixed(units?.details?.pv?.decimals);
        }
        return '';
      }
    },
    {
      field: 'yp',
      headerName: `YP (${units?.details?.yp?.label})`,
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell,
      valueGetter: params => {
        if (params?.row?.fann_300 && params?.row?.fann_600 && (params?.row?.fann_300 < params?.row?.fann_600) && (params?.row?.fann_200 < params?.row?.fann_300)) {
          const yp = params.row.fann_300 - (params.row.fann_600 - params.row.fann_300);
          return yp.toFixed(units?.details?.pv?.decimals);
        }
        return '';
      }
    },
    {
      field: 'gel_10min',
      headerName: `GEL 10 MIN (${units?.details?.gel_10min?.label})`,
      width: 220,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'gel_10sec',
      headerName: `GEL 10 SEC (${units?.details?.gel_10sec?.label})`,
      width: 220,
      renderCell,
      headerAlign: 'center',
      align: 'center',
      type: 'number'
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      renderCell: renderActions,
      headerAlign: 'center',
      align: 'center',
    }];
};

const bitTableDetails = (units) => {
  return [
    {
      field: 'type',
      headerName: 'Type',
      width: 185,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'size',
      headerName: `Size (${units?.size?.label})`,
      width: 185,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
    {
      field: 'tfa',
      headerName: `TFA (${units?.tfa?.label})`,
      width: 185,
      headerAlign: 'center',
      align: 'center',
      renderCell
    },
  ];
};

export function getWellDetailsColumns(value, units, renderActions) {
  switch (value) {
    case 'surveys':
      return surveryTableDetails(units?.surveys);
    case 'windows':
      return windowTableDetails(units?.windows);
    case 'geometries':
      return geometryTableDetails(units?.geometries);
    case 'drillStrings':
      return drillStringTableDetails(units?.drillStrings?.details);
    case 'drillFluids':
      return drillFluidTableDetails(units?.drillFluids, renderActions);
    case 'bits':
      return bitTableDetails(units?.drillStrings?.bit_details);
    default:
      return [];
  }
}
